<template>
  <div class="no-availability-modern">
    <svg class="no-availability-icon" width="64" height="64" viewBox="0 0 64 64" fill="none">
      <circle cx="32" cy="32" r="30" stroke="currentColor" stroke-width="2" stroke-dasharray="4 4"/>
      <path d="M32 20V36M32 44H32.01" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
    </svg>
    <h4>{{ $t("experiences.noAvailability") }}</h4>
    <p>{{ $t("experiences.tryAnotherDate") }}</p>

    <!-- Next Available Dates -->
    <NextAvailableSlots
      v-if="nextAvailableSlots && nextAvailableSlots.length > 0"
      :slots="nextAvailableSlots"
      @select="$emit('select-slot', $event)"
    />
  </div>
</template>

<script>
import NextAvailableSlots from './NextAvailableSlots.vue';

export default {
  name: 'NoAvailability',
  components: {
    NextAvailableSlots
  },
  props: {
    nextAvailableSlots: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.no-availability-modern {
  text-align: center;
  padding: 3rem 2rem;
  color: #6b7280;
}

.no-availability-icon {
  color: #d1d5db;
  margin: 0 auto 1.5rem;
  display: block;
}

.no-availability-modern h4 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--secondary-color);
  margin: 0 0 0.5rem 0;
}

.no-availability-modern p {
  margin: 0;
  font-size: 1rem;
}
</style>
